import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ParticipantFieldType,
  Participation,
  ParticipationSource,
  useIsAdmin,
} from '@app/api';
import { TableParticipationHeader } from '../../components/TableParticipationHeader';
import { Filter } from '../../components/Filter';
import {
  ParticipationSourceChips,
  participationSourceColors,
} from '../../components/ParticipationSourceChips';
import { TextLoadingPlaceholder } from '@app/core';
import { useParticipationTableContext } from './ParticipationTableContext';
import { TableColumnHeader } from './TableColumnHeader';

export const SourceHeader = () => {
  const { t } = useTranslation();
  const isAdmin = useIsAdmin();
  const { session, filtering } = useParticipationTableContext();

  return (
    <th key="source">
      <TableColumnHeader>
        <TableParticipationHeader
          fieldKey="source"
          fieldType={ParticipantFieldType.SHORT_TEXT}
        >
          <span>
            {t('sessions.details.participantsDetails.columns.source')}
          </span>
        </TableParticipationHeader>
        {isAdmin && (
          <Filter
            fieldRef="source"
            fieldLabel={t(
              'sessions.details.participantsDetails.columns.source',
            )}
            fieldType={ParticipantFieldType.TAGS}
            fieldValues={Object.values(ParticipationSource).map((s) => ({
              label: t(`sessions.details.monitoring.sources.${s}`),
              color: participationSourceColors[s],
              value: s,
            }))}
            sessionId={session.id}
            currentFilterData={filtering.getFieldCurrentFilter('source')}
            onFilterDataChange={filtering.handleFilterChange}
          />
        )}
      </TableColumnHeader>
    </th>
  );
};

export const SourceCell = ({
  participation,
}: {
  participation: Participation;
}) => {
  return (
    <td key="source">
      <ParticipationSourceChips participation={participation} />
    </td>
  );
};

export const SourceLoader = () => {
  const { t } = useTranslation();
  return (
    <td key="source">
      <TextLoadingPlaceholder
        sample={t('sessions.details.participantsDetails.columns.source')}
      />
    </td>
  );
};
